
  var _styles = {
  "card-container": {
    "width": "9.36rem",
    "padding": "0.32rem",
    "marginBottom": "0.32rem",
    "borderRadius": "0.2rem",
    "backgroundColor": "rgb(255,255,255)",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "stretch"
  },
  "right-container": {
    "marginLeft": "0.32rem"
  },
  "location": {
    "width": "5.89333rem",
    "marginTop": "0.16rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(102,102,102)",
    "letterSpacing": 0,
    "lineHeight": "0.36rem"
  }
};



  module.exports = _styles;
  